module.exports = __webpack_public_path__ + "img/banner.7b654afc.jpg";